import { Trans, useTranslation } from 'react-i18next';
import Video from '../../assets/535fbac30da553a0.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const HistorySection1 = () => {
  const { t } = useTranslation();
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);
  
  return (
    <VerticalLayout style={{
      background: 'black',
      ...(isMobile ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: '100%',
            height: isMobile ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            left: `${padding}px`,   // ✅ 좌측 여백
            bottom: isMobile ? isEng ? '180px' : isChina ? '136px' : '114px' : `${topSectionBottom}px`   // ✅ 하단 여백
          }}
        >
          {isMobile ? (
            <>
            History of BBTECH
            </>
          ) : (
            <>
            History of<br />BBTECH
            </>
          )}
        </SubH1>
        <H10
          style={{
            width: isMobile ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? '0px' : `${topSectionBottom}px`,
            ...(isMobile
              ? { left: `${padding}px`, minHeight: isEng ? '168px' : isChina ? '124px' : '102px' }
              : { right: `${padding}px` }),
          }}
        >
          <Trans i18nKey='비비테크는 지난 20년간 끊임없는 기술 혁신과 정직한 품질로 산업의 믿음을 쌓아왔습니다. 축적된 경험과 노하우를 바탕으로, 더 나은 내일을 향한 해답을 제시합니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default HistorySection1;
